import { observer } from 'mobx-react'

import formatCurrency from 'modules/core/lib/formatCurrency'
import { currencyToNumber } from 'modules/core/lib/formatCurrencyUtils'

const DisplayAmount = ({ amount }: { amount: string }) => {
  const CENT = 100
  const trimmedSalary = String(amount).trim()
  const value = formatCurrency(currencyToNumber(trimmedSalary) * CENT)

  return <>{value}</>
}

export default observer(DisplayAmount)
